import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LayoutComponent } from "./layout.component";
import { RouterModule } from "@angular/router";
import { NgxSpinnerModule } from "ngx-spinner";
import { BsModalService, ModalModule } from "ngx-bootstrap/modal";
import { TopBarComponent } from "./top-bar/top-bar.component";
import { AuthService } from "../domains/auth/services/auth.service";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ModalModule,
    NgxSpinnerModule,
  ],
  declarations: [
    LayoutComponent,
    TopBarComponent,
  ],
  providers: [
    AuthService,
    BsModalService,
  ]
})
export class LayoutModule { }
